import { Calibration } from 'common/types/valuation/valuation';

interface UseDisabledPerformancesProps {
  calibration: Calibration;
}

const useDisabledPerformances = ({ calibration }: UseDisabledPerformancesProps) => {
  const disabledPerformances = calibration?.performances?.filter(performance => !performance.enabled);
  const disabledNames = disabledPerformances?.map(performance => performance.name);
  const disabledIdentifiers = disabledPerformances?.map(performance => performance.cap_iq_id).filter(id => id);

  return { disabledNames, disabledIdentifiers };
};

export default useDisabledPerformances;
